import {Component, Input, OnInit} from '@angular/core';
import {BlogService} from '../blog.service';

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
    @Input() backgroundColour = 'bg-grey';

    categories = [];

    constructor(
        private blogService: BlogService,
    ) {
    }

    ngOnInit(): void {
        this.getCategories();
    }

    getCategories() {
        this.blogService.getCategories().subscribe(data => {
            this.categories = data.data;
        });
    }
}
